const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  tags: [],
  search: "",
  pageNo: 1,
  author: "",
};

const filterSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    tagSelected: (state, action) => {
      state.tags.push(action.payload);
    },
    tagRemoved: (state, action) => {
      const indexToRemove = state.tags.indexOf(action.payload);

      if (indexToRemove !== -1) {
        state.tags.splice(indexToRemove, 1);
      }
    },
    resetTag: (state, action) => {
      state.tags = [];
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
    setPageNo: (state, action) => {
      state.pageNo = action.payload;
    },
    setAuthor: (state, action) => {
      state.author = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const {
  tagSelected,
  tagRemoved,
  resetTag,
  searched,
  setPageNo,
  setAuthor,
} = filterSlice.actions;
